<script setup lang="ts">
import CustomButton from "@/components/Button/Button.vue";
import { useRouter } from "vue-router";
import CustomModal from "@/components/CustomModal/CustomModal.vue";

const router = useRouter();

defineProps({
  showThanksModal: Boolean
});
defineEmits(["close"]);

</script>

<template>

  <CustomModal
      :show="showThanksModal"
      classes="w-1/6"
      :custom-index="40"
      extra-classes="h-fit !overflow-visible"
      drawerHeight="'100%'"
  >


    <div class="relative sm:min-w-[200px] md:min-w-[400px] bg-white ">

      <button
          @click="$emit('close')"
          class="absolute top-5 right-4 cursor-pointer responsive-body-xsmall"
      >
        ✕
      </button>

      <div class="flex flex-col gap-2 items-center p-8 w-full">
        <img
            src="@/assets/inquiry/bottle.svg"
            alt="Thank you"
            class="md:w-[10vw] sm:w-[15vw] drop-shadow-lg mt-8"
        />

        <!-- Heading -->
        <h1 class="mt-4 font-bold responsive-title-4 text-primary-darkBlue text-center">
          Thank you for your inquiry!
        </h1>

        <!-- Subheading -->
        <p class="mt-4 text-bw-midGrey text-center max-w-xl responsive-body-medium ">
          We’ve received your request and one of our team members will get back to you shortly.
          In the meantime, feel free to explore more yachts and destinations.
        </p>

        <!-- Button -->
        <CustomButton
            type="red"
            size="medium"
            :rounded="true"
            class="mt-8 w-fit font-semibold"
            @click="router.push('/yachts'); $emit('close')"
        >
          Browse Yachts
        </CustomButton>
      </div>
    </div>

  </CustomModal>
</template>

